export const markRequired = (isRequired = false, label) => isRequired ? `${label}*` : label;
//# sourceMappingURL=mark_required.js.map